var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useEffect, useState } from 'react';
import { isFalsy } from '../../../utils/common';
import SectionHeader from './SectionHeader';
import SimilarCourseCard from './SimilarCourseCard';
import GBSlider from './Slider';
import { COMPONENT_ID_ENUM } from './types';
var SimilarCourses = function (_a) {
    var _b;
    var similarCourses = _a.similarCourses, onPdfDownload = _a.onPdfDownload, onCourseShortlist = _a.onCourseShortlist, onCsvDownload = _a.onCsvDownload, partnerName = _a.partnerName, className = _a.className, hideHeaderDivider = _a.hideHeaderDivider, headerClassName = _a.headerClassName, similarCoursePrimaryCtaProps = _a.similarCoursePrimaryCtaProps, onCustomCopyClick = _a.onCustomCopyClick;
    var getCurrentDimension = function () {
        var _a, _b;
        return {
            width: (_a = window === null || window === void 0 ? void 0 : window.innerWidth) !== null && _a !== void 0 ? _a : 0,
            height: (_b = window === null || window === void 0 ? void 0 : window.innerHeight) !== null && _b !== void 0 ? _b : 0
        };
    };
    var slideShowCount = function (count) {
        if (count === 1 || (screenSize === null || screenSize === void 0 ? void 0 : screenSize.width) < 1024) {
            return 1;
        }
        return 2;
    };
    var _c = __read(useState(getCurrentDimension()), 2), screenSize = _c[0], setScreenSize = _c[1];
    useEffect(function () {
        var updateDimension = function () {
            setScreenSize(getCurrentDimension());
        };
        window.addEventListener('resize', updateDimension);
        return function () {
            window.removeEventListener('resize', updateDimension);
        };
    }, [screenSize]);
    if (isFalsy(similarCourses))
        return null;
    return (React.createElement("div", { className: "".concat(className !== null && className !== void 0 ? className : 'lfc-bg-white lfc-p-3 lg:lfc-p-4 lfc-rounded-lg lfc-relative '), id: COMPONENT_ID_ENUM.COURSE_DETAILS_SIMILAR_COURSES },
        React.createElement(SectionHeader, { title: "Similar Courses", hideDivider: hideHeaderDivider, headerClassName: headerClassName }),
        React.createElement(GBSlider, { arrowPlacement: "bottom-right", sliderProps: {
                slidesToShow: slideShowCount((_b = (similarCourses !== null && similarCourses !== void 0 ? similarCourses : [])) === null || _b === void 0 ? void 0 : _b.length),
                autoplay: true,
                speed: 950,
                autoplaySpeed: 7500,
                responsive: [
                    {
                        breakpoint: 475,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 2
                        }
                    }
                ]
            }, slideContainerClasses: {
                'div:first-child': {
                    height: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    '&+div~div': { flex: 1 }
                },
                '&:only-child': {
                    display: 'flex',
                    flexDirection: 'column'
                }
            }, sliderTopBoxContainerStyles: {
                px: 0
            }, slidesToScrollCallbackCondition: function () {
                return 2;
            } }, similarCourses === null || similarCourses === void 0 ? void 0 : similarCourses.map(function (course) {
            if (!(course === null || course === void 0 ? void 0 : course.courseId))
                return null;
            // return <div key={course?.courseId}>{course?.courseName}</div>;
            return (React.createElement(SimilarCourseCard, { key: course === null || course === void 0 ? void 0 : course.id, course: course, onPdfDownload: onPdfDownload, onCourseShortlist: onCourseShortlist, onCsvDownload: onCsvDownload, partnerName: partnerName, primaryCtaProps: similarCoursePrimaryCtaProps, onCustomCopyClick: onCustomCopyClick }));
        }))));
};
export default SimilarCourses;
//# sourceMappingURL=SimilarCourses.js.map